export default function AppFooter() {
  return (
    <footer className="w-full border-t border-surface-200 dark:border-surface-800 bg-white/80 dark:bg-[#1b1b1f]/80 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-surface-500 dark:text-surface-400">
        <span>&copy; 2026 &mdash; Tutti i diritti riservati.</span>
        <span>
          Sviluppato da{' '}
          <a
            href="https://testscript.info"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary-600 dark:text-primary-400 hover:underline"
          >
            testscript
          </a>
        </span>
      </div>
    </footer>
  );
}
